














































































































































































import { Component, Vue } from "vue-property-decorator";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

@Component<AileTemelliArabuluculuk>({
  metaInfo() {
    return {
      title: this.pageTitle
    };
  },
  components: {
    Breadcrumbs
  }
})
export default class AileTemelliArabuluculuk extends Vue {
  pageTitle = "Aile Temelli Arabuluculuk Sertifika Programı";

  get breadcrumbs(): unknown[] {
    return [
      {
        text: "Ana Sayfa",
        exact: true,
        to: { name: "Home" }
      },
      {
        text: "Program Kataloğu",
        exact: true,
        to: { name: "ProgramCatalog" }
      },
      {
        text: this.pageTitle
      }
    ];
  }

  get isUserLoggedIn(): boolean {
    return this.$store.getters["auth/isUserLoggedIn"];
  }
}
